import React, { lazy, Suspense } from "react";
import Skeleton from '@material-ui/lab/Skeleton';

import Banner from "../Banner/Banner";
import ResortCard from "../Resort/ResortCard";

import styles from "./styles";
import useGlobal from "../../store";
const Booking = lazy(() => import('../Booking/Booking.jsx'));

export default function Home() {
	const classes = styles();
	const [globalState, globalActions] = useGlobal();
	const { contactUs } = globalState.cmsContext;
	const { resorts, banners } = globalState.homeContext;
	const renderLoader = () => <Skeleton animation="wave" variant="rect" height={570} width={275} />;


	return (
		<div>
			<div className={classes.bannerwrapper}>
				<div className={classes.bwrapper}>
				<Suspense fallback={renderLoader()}>
					<Booking />
					</Suspense>
					{banners && banners.length && 
						<Banner banners={banners} type={'home'} />
					}
				</div>
				<span className={classes.leafwrapper}></span>
				<div className="clear"></div>
			</div>
			<div className={"contentsWrap"}>
				<section className="aboutContent">
					<div className="playfair h1">
						{contactUs.title}<br></br> Hotels & Resorts
					</div>
					<p>
						{contactUs.description}
					</p>
				</section>
				<section className={classes.secMB}>
					<div className="playfair h1">Hotels & Resorts</div>
					<ul className={classes.cardsmain}>
						{resorts && resorts.length && 
							resorts.map((resort, key) => (
									<ResortCard resort={resort} key={key} type="home" />
							))
						}
					</ul>
					<div className="clear"></div>
				</section>
			</div>
		</div>
	);
}
